import { ConfigProvider } from 'antd';
import { HotkeysProvider } from '@/components/Business//TabsLayout/HotkeysContext';
import { OAProcessModalProvider } from '@/contexts/OAProcessModalContext';
import { useOAModals } from '@/hooks/useOAProcessModal';

// import MaxTabs from '@/layouts/max-tabs';
import { MaxTabsLayout } from '@umijs/max';

const ChildrenContent = () => {
  const { renderAllOAModals } = useOAModals();

  return (
    <>
      <MaxTabsLayout />
      {/* OA Modal 单例统一挂载在顶层 */}
      {renderAllOAModals()}
    </>
  );
};

const Children = () => {
  return (
    <ConfigProvider
      wave={{
        disabled: true,
      }}
      theme={{
        token: {
          motion: false,
          motionDurationMid: '0s',
          motionDurationFast: '0s',
          motionDurationSlow: '0s',
         },
        components: {
          Input: {
            colorTextDisabled: '#222222',
          },
          // Select: {
          //   colorTextDisabled: '#222222',
          // },
          Wave: false
        },
      }}
    >
      <HotkeysProvider>
        <OAProcessModalProvider>
          <ChildrenContent />
        </OAProcessModalProvider>
      </HotkeysProvider>
    </ConfigProvider>
  );
};

export default Children;
